import React from "react";
import { ArrowUpRight, ArrowDownRight, Trash2, Pencil } from "lucide-react";
import { toast } from "sonner";
import api, { TRY, trDate, formatApiError, weekendRow } from "@/lib/api";
import { Card } from "@/components/Cards";

export default function SupplierLedgerTable({ txns, onChanged, onEdit, onDetail }) {
  const del = async (id) => {
    try { await api.delete(`/supplier-ledger/${id}`); toast.success("İşlem silindi"); onChanged(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const H = ["Tarih", "Tedarikçi", "İşlem", "Yöntem", "Vade", "Alış (Borç)", "Ödeme", ""];
  return (
    <Card className="overflow-hidden" data-testid="supplier-ledger-table">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-border bg-muted/40 text-left">
            {H.map((h, i) => <th key={i} className={`px-4 py-3 text-xs font-semibold uppercase tracking-wider text-muted-foreground ${i === 5 || i === 6 ? "text-right" : ""}`}>{h}</th>)}
          </tr></thead>
          <tbody>
            {txns.length === 0 ? <tr><td colSpan={8} className="px-4 py-12 text-center text-muted-foreground">Hareket bulunamadı</td></tr>
              : txns.map((t) => (
                <tr key={t.id} data-testid={`supplier-txn-row-${t.id}`} onClick={() => t.lines && onDetail?.(t)} className={"border-b border-border/60 hover:bg-accent/40 transition-colors" + (t.lines ? " cursor-pointer" : "") + weekendRow(t.date)}>
                  <td className="px-4 py-3 font-mono text-xs text-muted-foreground whitespace-nowrap">{trDate(t.date)}</td>
                  <td className="px-4 py-3 font-medium">{t.supplier_name}</td>
                  <td className="px-4 py-3">
                    <span className={`inline-flex items-center gap-1.5 text-xs font-medium ${t.type === "purchase" ? "text-rose-400" : "text-emerald-400"}`}>
                      {t.type === "purchase" ? <ArrowUpRight className="h-3.5 w-3.5" /> : <ArrowDownRight className="h-3.5 w-3.5" />}
                      {t.description}{t.invoice_no && <span className="text-muted-foreground">· No: {t.invoice_no}</span>}
                      {t.cost_category && <span className="ml-1 rounded bg-muted px-1.5 py-0.5 text-[10px] text-muted-foreground">{t.cost_category}</span>}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-xs text-muted-foreground">{t.method || "—"}</td>
                  <td className="px-4 py-3 text-xs whitespace-nowrap">{t.type === "purchase" && t.due_date ? <span className={t.overdue ? "text-rose-400 font-semibold" : "text-muted-foreground"}>{trDate(t.due_date)}{t.overdue && " ⚠"}</span> : "—"}</td>
                  <td className="px-4 py-3 text-right font-mono">{t.type === "purchase" ? TRY(t.amount) : "—"}</td>
                  <td className="px-4 py-3 text-right font-mono text-emerald-400">{t.type === "payment" ? TRY(t.amount) : "—"}</td>
                  <td className="px-4 py-3 text-right whitespace-nowrap" onClick={(e) => e.stopPropagation()}>
                    {t.type === "purchase" && t.lines && onEdit && <button onClick={() => onEdit(t)} data-testid={`supplier-txn-edit-${t.id}`} title="Faturayı düzenle" className="h-7 w-7 mr-1 rounded-md hover:bg-accent inline-flex items-center justify-center text-muted-foreground hover:text-foreground"><Pencil className="h-3.5 w-3.5" /></button>}
                    <button onClick={() => del(t.id)} data-testid={`supplier-txn-delete-${t.id}`} className="h-7 w-7 rounded-md hover:bg-destructive/10 inline-flex items-center justify-center text-muted-foreground hover:text-destructive"><Trash2 className="h-3.5 w-3.5" /></button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
